import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { Layout } from 'antd';
import { useHeaderOffset } from '../Header/useHeaderOffset';
import { useResultsSearchContext } from '../Header/MobileResultsSearchContext';
import {
  SEARCH_RESULT_PATHS,
  usesCompactSearchBar,
  isVendorDetailPath,
} from '../../siteConfigs/serviceCategories';
import { useLoggedInUser } from '../../stores/sessionStore';

const { Content } = Layout;

export default function AppContent({ children }) {
  const user = useLoggedInUser();
  const { pathname } = useLocation();
  const isLoggedIn = Boolean(user && user.id);
  const { resultsSearchExpanded } = useResultsSearchContext();
  const { offset: headerOffset } = useHeaderOffset(pathname, isLoggedIn);
  const isResultsPage = SEARCH_RESULT_PATHS.includes(pathname);
  const isVendorDetail = isVendorDetailPath(pathname);
  const compactCollapsed =
    usesCompactSearchBar(pathname) && !resultsSearchExpanded;

  return (
    <Content
      className={
        compactCollapsed
          ? 'site-main-content site-main-content--compact-search'
          : 'site-main-content'
      }
      style={{
        marginTop: isVendorDetail ? 0 : `${headerOffset}px`,
        backgroundColor: isResultsPage ? '#f7f7f7' : undefined,
        position: 'relative',
        zIndex: 0,
      }}
    >
      {children}
    </Content>
  );
}

AppContent.propTypes = {
  children: PropTypes.node,
};
